/**
 * Client-side mirror of server/server/utils/widget-fetch-hosts.js
 */

const FOT_FETCH_URL_RE = /fot\.fetch\s*\(\s*(['"`])(https:\/\/[^'"`\s]+)\1/g;

function hostnameFromUrl(urlString) {
  try {
    return new URL(urlString).hostname.toLowerCase() || null;
  } catch {
    return null;
  }
}

export function extractWidgetFetchHosts(jsContent) {
  if (!jsContent || typeof jsContent !== 'string') return [];
  const hosts = new Set();
  let match;
  const re = new RegExp(FOT_FETCH_URL_RE.source, 'g');
  while ((match = re.exec(jsContent)) !== null) {
    const host = hostnameFromUrl(match[2]);
    if (host) hosts.add(host);
  }
  return [...hosts].sort();
}

export function parseAllowedHostsInput(raw) {
  if (!raw || typeof raw !== 'string') return [];
  return [...new Set(
    raw.split(/[\s,;]+/).map((h) => h.trim().toLowerCase()).filter(Boolean)
  )];
}

export function mergeAllowedHostsInput(existingRaw, extractedHosts) {
  const merged = new Set([
    ...parseAllowedHostsInput(existingRaw),
    ...extractedHosts.map((h) => h.toLowerCase())
  ]);
  return [...merged].join(', ');
}
